<template>
    <el-container>
        <el-header height="auto">
            <el-form :inline="true" :model="queryForm" class="demo-form-inline">
                <el-form-item label="扩展名称">
                    <el-input size="mini" v-model="queryForm.name" placeholder="扩展名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-container>
            <el-header height="auto">
                <el-button size="mini" icon="el-icon-document-add" type="primary" @click="showPop">新增</el-button>
                <el-button size="mini" icon="el-icon-edit" type="primary" @click="edit">编辑</el-button>
                <el-button size="mini" :plain="true" icon="el-icon-delete" type="primary" @click="remove">删除</el-button>
            </el-header>
            <el-main>
                <el-table :data="list" style="width: 100%">
                    <el-table-column
                        prop="extensionCode"
                        label="扩展编码"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="extensionName"
                        label="扩展名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="systemCode"
                        label="系统名称">
                    </el-table-column>
                </el-table>
            </el-main>
        </el-container>
        <index-pop v-if="popFormIsShow" @hide="popFormHide" @save="add" :data="popForm"></index-pop>
    </el-container>
</template>
<script>
    import IndexPop from "./IndexPop.vue";
    export default {
        components:{
            IndexPop
        },
        data() {
            return {
                queryForm: {
                    name: ''
                },
                popForm:{
                    extensionName:"",
                },
                popFormIsShow:false,
                extensionPopShow:false,
                list:[]
            }
        },
        methods: {
            onSearch() {
                console.log('submit!');
            },
            showPop(){
                this.popFormIsShow=true
            },
            popFormHide(){
                this.popFormIsShow=false;
            },
            remove(){

            },
            edit(){

            },
            add(data){
                console.log(data)
            },
            reset(data){
                for(let key in data){
                    if(data.hasOwnProperty(key)){
                        data[key]="";
                    }
                }
            }
        },
        mounted(){

        }
    }
</script>
